import { DragEvent } from 'react';

import { DragStrategy } from './dragStrategy';

export class DragStrategyParent extends DragStrategy {
    onDragOver(e: DragEvent<HTMLDivElement>, access: boolean): boolean {
        if (!super.onDragOver(e, access)) {
            return false;
        }

        const itemOverProjectId = this.getProjectId(e);
        if (itemOverProjectId === this.itemBeingDraggedProjectId) {
            this.setRowBorder(this.dragOverItemId);
        } else {
            this.dragOverItemId = '';
        }
        return true;
    }

    onDragLeave(): void {
        if (this.dragOverItemId) {
            this.removeRowBorder(this.dragOverItemId);
        }
    }

    onDragStart(e: DragEvent<HTMLDivElement>): boolean {
        return super.onDragStart(e);
    }

    onDragEnd(e: DragEvent<HTMLDivElement>): string | null {
        const dropItemId = super.onDragEnd(e);
        this.removeRowBorder(this.dragOverItemId);
        return dropItemId;
    }
}
